<div [formGroup]="form">
  <h4 class="u-padding-top-15">
    {{'organization.create.section_3.exceptions' | translate}}
    <span
      class="l-updated-component"
      *ngIf="isnodeConfig && orgConfig && orgConfig.exceptions && orgConfig.exceptions.isOverride"
    ></span>
  </h4>
  <button
    id="btnAddNewException"
    type="button"
    mat-icon-button
    matTooltipPosition="above"
    (click)="addExceptionRow();"
    [disabled]="action=='view'"
  >
    <mat-icon>add_box</mat-icon>
  </button>
  <table
    id="matTableException"
    mat-table
    [dataSource]="exceptionDataSource"
    formArrayName="exceptions"
  >
    <tr id="matHeaderRowException" mat-header-row *matHeaderRowDef="execeptionColumns"></tr>
    <tr id="matRowException" mat-row *matRowDef="let row; columns: execeptionColumns"></tr>

    <ng-container matColumnDef="from">
      <th mat-header-cell *matHeaderCellDef>
        {{'organization.create.section_3.from_date' | translate}}
      </th>

      <td mat-cell *matCellDef="let exception; let index = index" [formGroupName]="index">
        <mat-form-field id="matFrmFieldFromDate{{index}}" class="mat-block">
          <input
            id="txtFromDate{{index}}"
            matInput
            formControlName="from"
            [matDatepicker]="picker"
            [placeholder]="'organization.create.section_3.from_date' | translate"
            required
            (dateChange)="fromDateChange(index, $event);"
            readonly
            (click)="picker.open()"
            [disabled]="action === 'view'"
          />
          <mat-datepicker-toggle id="matDatePickerToggleFromDate{{index}}" matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker id="matDatePickerFromDate{{index}}" #picker></mat-datepicker>
          <mat-error
            id="matFromDateRequired{{index}}"
            class="error-message"
            *ngIf="
  (exceptionAt(index)['controls'].from.dirty  ||
   exceptionAt(index)['controls'].from.touched) "
          >
            {{ "organization.create.section_3.exception_from_date_required" | translate }}
          </mat-error>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="to">
      <th mat-header-cell *matHeaderCellDef>
        {{'organization.create.section_3.to_date' | translate}}
      </th>
      <td mat-cell *matCellDef="let exception; let index = index" [formGroupName]="index">
        <mat-form-field id="matFrmFieldToDate{{index}}" class="mat-block">
          <input
            id="txtFromDate{{index}}"
            matInput
            formControlName="to"
            [min]="exceptionAt(index)['controls'].to.value"
            [matDatepicker]="picker"
            [placeholder]="'organization.create.section_3.to_date' | translate"
            required
            readonly
            (click)="picker.open()"
            [disabled]="action === 'view'"
          />
          <mat-datepicker-toggle id="matDatePickerToggleToDate{{index}}" matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker id="matDatePickerToDate{{index}}" #picker></mat-datepicker>
          <mat-error
            id="matToDateRequired{{index}}"
            class="error-message"
            *ngIf="
    exceptionAt(index)['controls'].to.dirty ||
    exceptionAt(index)['controls'].to.touched"
          >
            {{ "organization.create.section_3.exception_to_date_required" | translate }}
          </mat-error>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="reason">
      <th mat-header-cell *matHeaderCellDef>
        {{'organization.create.section_3.reason' | translate}}
      </th>
      <td mat-cell *matCellDef="let exception; let index = index" [formGroupName]="index">
        <mat-form-field id="matFrmFieldReason{{index}}" class="mat-block">
          <!-- <mat-select
            id="matSelectReason{{index}}"
            formControlName="reason"
            [placeholder]="'organization.create.section_3.select_reason' | translate"
          >
            <mat-option *ngFor="let reason of reasonList" [value]="reason">
              {{ reason }}
            </mat-option>
          </mat-select> -->
          <input
            id="matSelectReason{{index}}"
            matInput
            [placeholder]="'organization.create.section_3.select_reason' | translate"
            formControlName="reason"
            onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
            maxlength="18"
          />
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="openTime">
      <th mat-header-cell *matHeaderCellDef>
        {{'organization.create.section_3.open_time' | translate}}
      </th>
      <td mat-cell *matCellDef="let exception; let index = index" [formGroupName]="index">
        <mat-form-field id="matFrmFieldOpenTime{{index}}" class="mat-block">
          <input id="txtOpenTime{{index}}" matInput type="time" formControlName="openTime" />
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="closeTime">
      <th mat-header-cell *matHeaderCellDef>
        {{'organization.create.section_3.close_time' | translate}}
      </th>
      <td mat-cell *matCellDef="let exception; let index = index" [formGroupName]="index">
        <mat-form-field id="matFrmFieldCloseTime{{index}}" class="mat-block">
          <input id="txtCloseTime{{index}}" matInput type="time" formControlName="closeTime" />
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef style="width: 124px;">
        {{'organization.create.section_3.action' | translate}}
      </th>
      <td mat-cell *matCellDef="let exception; let index = index">
        <button
          id="btnDeleteException"
          mat-icon-button
          matTooltipPosition="above"
          [matTooltip]="'organization.create.section_3.delete' | translate"
          (click)="deleteExceptionRow(index);"
          [disabled]="action === 'view'"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
  </table>
</div>
